import { Layout, Col, Input, Row, Button } from "antd";
import styled from "styled-components";

const { Sider, Content, Header } = Layout;

const ContentRow = styled(Row)`
  height: 100vh;
`;

const FormCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const FormInput = styled(Input)`
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
`;

const FormPassword = styled(Input.Password)`
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
`;

const FormButton = styled(Button)`
  margin-top: 20px;
  height: 40px;
  border-radius: 5px;
`;

const NavigateBar = styled.div`
  margin-top: 20px;
`;

const NavigateButton = styled(Button)``;

const MainLayout = styled(Layout)`
  min-height: 100vh;
`;

const SideBarHeader = styled.div`
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoTitle = styled.span`
  color: white;
  font-size: 20px;
`;

const LogoutButton = styled(Button)`
  color: black;
`;

const SPHeader = styled(Header)`
  text-align: right;
  background: #1877f2;
`;

const SPSider = styled(Sider)`
  /* background: #0e256e; */
`;

const SPWider = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SPContent = styled(Content)`
  padding: 20px;
`;

const ContentHeader = styled.div`
  font-size: 18px;
  font-weight: bold;
  height: 60px;
  display: flex;
  align-items: center;
`;

const ActionButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

const DrawerFooter = styled.div`
  flex-shrink: 0;
  padding: 10px 0px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
  position: absolute;
  bottom: 0px;
  width: calc(100% - 48px);
  background-color: #fff
`;

const BreadCrumbWrapper = styled.div`
  height: 60px;
  align-items: center;
  display: flex;
  font-weight: bold;
  position: relative;
`;

const RightButton = styled(Button)`
  position: absolute;
  right: 0;
`;

const FullNameText = styled.span`
  font-size: 13px;
  margin-left: 5px;
  color: white;
`;

export {
  MainLayout,
  SideBarHeader,
  LogoTitle,
  ContentRow,
  FormCol,
  FormInput,
  FormButton,
  NavigateBar,
  NavigateButton,
  LogoutButton,
  SPHeader,
  SPSider,
  SPWider,
  SPContent,
  ContentHeader,
  ActionButtonWrapper,
  DrawerFooter,
  BreadCrumbWrapper,
  RightButton,
  FullNameText,
  FormPassword,
};
